import { ModelRow, Navigation } from "@mcleod/core";
import { Label, Image, TableRow, TableRowDisplayEvent, DataSourceExecutionEvent, ClickEvent, Panel } from "@mcleod/components";
import { AutogenLayoutPreassignOrderQuickInfoTable } from "./autogen/AutogenLayoutPreassignOrderQuickInfoTable";
import { ImageName } from "@mcleod/images";
import { CommonTooltips } from "@mcleod/common";
import { OrderTabView } from "../OrderTabView";

export class PreassignOrderQuickInfoTable extends AutogenLayoutPreassignOrderQuickInfoTable {
    tablePreassignOrdersOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow();
        const modelRow: ModelRow = tableRow.data;
        const labelOrderId = tableRow.findComponentById("labelOrderId") as Label;
        const zmitImage = tableRow.findComponentById("imageZmit") as Image;
        const holdImage = tableRow.findComponentById("imageHold") as Image;

        const xmitted2driver = modelRow.getBoolean("xmitted2driver");
        const xmitAccepted = modelRow.get("xmit_accepted");
        this.displayZmitImage(zmitImage, xmitted2driver, xmitAccepted);

        if (labelOrderId && !modelRow.isNull("order_id") && modelRow.get("loaded") == "L") {
            labelOrderId.link = `lme/dispatch/OrderTabView?mode\u003dupdate\u0026key\u003d${modelRow.get("order_id")}`;
            labelOrderId.handleLinkClick = (event) => Navigation.navigateTo(labelOrderId.link, {newTab: true});
            labelOrderId.tooltip = "Click to view order";
            labelOrderId.addUnderlineWhenMouseOver();
        } else if (modelRow.get("loaded") == "E") {
            const panelOrderNumber = tableRow.findComponentById("panelOrderNumber") as Panel;
            const panelEmptyOrder = tableRow.findComponentById("panelEmptyOrder") as Panel;
            const labelEmptyOrder = tableRow.findComponentById("labelEmptyOrder") as Label;
            panelOrderNumber?.setProps({ visible: false });
            panelEmptyOrder.visible = true;
            labelEmptyOrder?.addUnderlineWhenMouseOver();
            labelEmptyOrder?.setStyleProps({ textDecoration: "underline"})
        }

        if (holdImage) {
            holdImage.visible = modelRow.getBoolean("on_hold");
            if (holdImage.visible) {
                CommonTooltips.setTooltipContentTextboxes(holdImage, () => [{
                    caption: "Reason",
                    text: tableRow.data.get("hold_reason")
                }]);
            }
        }
    }

    private displayZmitImage(zmitImage: Image, xmitted2driver: boolean, xmitAccepted: string) {
        const imageProps = this.getZMitImageProps(!xmitted2driver, xmitAccepted);

        zmitImage.visible = imageProps.name !== null;
        zmitImage.name = imageProps.name;
        zmitImage.field = imageProps.field;
        zmitImage.displayLabel = imageProps.displayLabel;
        zmitImage.tooltip = imageProps.tooltip;
    }

    private getZMitImageProps(zMitNotTransmitted: boolean, zmitAccepted: string): { name: ImageName, field: string, displayLabel: string, tooltip: string } {
        if (zMitNotTransmitted) {
            return { name: null, field: "xmitted2driver", displayLabel: "Load Not Transmitted", tooltip: "Load Not Transmitted" }
        } else if (zmitAccepted == null) {
            return { name: ImageName.zMitTransmitted, field: "xmitted2driver", displayLabel: "Load Transmitted", tooltip: "Load Transmitted" }
        } else if (zmitAccepted === 'Y') {
            return { name: ImageName.zMitTransmittedAccepted, field: "xmit_accepted", displayLabel: "Load Accepted", tooltip: "Load Accepted" }
        } else if (zmitAccepted === 'N') {
            return { name: ImageName.zMitTransmittedRejected, field: "xmit_accepted", displayLabel: "Load Rejected", tooltip: "Load Rejected" }
        }

        return { name: null, field: "xmitted2driver", displayLabel: null, tooltip: null };
    }

    /** This is an event handler for the afterExecution event of sourcePreassignments. */
    sourcePreassignmentsAfterExecution(event: DataSourceExecutionEvent) {
        const shouldSetColumnWidth = this.tablePreassignOrders.rows.some(row => {
            const modelRow = row.data;
            if (!modelRow) return false;

            const xmitted2driver = modelRow.getBoolean("xmitted2driver");
            const xmitAccepted = modelRow.get("xmit_accepted");
            const imageProps = this.getZMitImageProps(!xmitted2driver, xmitAccepted);
            const isOnHold = modelRow.getBoolean("on_hold");

            return imageProps.name !== null && isOnHold;
        });

        if (shouldSetColumnWidth) {
            this.setColumnWidth("columnHeaderZmitHold", 60);
        }
    }

    private setColumnWidth(columnId: string, width: number | string) {
        const targetColumn = this.tablePreassignOrders.columns.find(column =>
            column?.headingCell?.id === columnId
        );

        if (targetColumn) {
            targetColumn.headingCell.width = width;
            targetColumn.cellDef.def.width = width;
        }
    }

    labelEmptyOrderOnClick(event: ClickEvent) {
        const tableRow = TableRow.getContainingTableRow(event.target as Label);
        const modelRow = tableRow.data;
        OrderTabView.navigateTo({ key: modelRow.get("movement_id"), orderId: modelRow.get("order_id", "none"), newTab: true });
    }
}
